export default "__VITE_ASSET__CeomDYnC__"